export default __webpack_public_path__ + "img/XwYbLNXC.9febdb11.svg";